export default __webpack_public_path__ + "static/media/logo.1ea1a181.svg";